import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { usePrefs, useLabels } from 'wsm-common-data';
import FacetButtonLink from '../FacetButtonLink';

import Facet from '../Facet';

const StoreList = ({
	stores = [],
	groupId,
	inputType,
	handleChange,
	handleSelect
}) => {
	const [showTruncatedStoreList, setShowTruncatedStoreList] = useState(true);
	const [displayedStores, setDisplayedStores] = useState([]);

	const labels = useLabels();
	const prefs = usePrefs();

	const { truncateLocations } = prefs;
	const showTruncatedLocations = truncateLocations === 'true';

	useEffect(() => {
		if (showTruncatedLocations && showTruncatedStoreList) {
			setDisplayedStores(stores.slice(0, 5));
		} else {
			setDisplayedStores(stores);
		}
	}, [stores, showTruncatedStoreList, showTruncatedLocations]);

	if (!displayedStores?.length) {
		return null;
	}

	return (
		<>
			<ul className="list-unstyled line-height-condensed">
				{displayedStores?.map((item) => {
					return (
						<Facet
							facetLabel={item.label}
							inputType={inputType}
							facetValue={item.value}
							facetCount={item.count}
							groupId={groupId}
							isDisabled={false}
							onChange={handleChange}
							key={`${groupId}-${item.value}`}
							handleSelect={handleSelect}
						/>
					);
				})}
			</ul>
			{showTruncatedLocations && stores.length > 5 && (
				<FacetButtonLink
					buttonText={
						showTruncatedStoreList
							? labels.get('LOCATION_TRUNCATION')
							: labels.get('SHOW_LESS')
					}
					onClick={() => setShowTruncatedStoreList((prev) => !prev)}
				/>
			)}
		</>
	);
};

StoreList.propTypes = {
	stores: PropTypes.arrayOf(
		PropTypes.shape({
			count: PropTypes.number.isRequired,
			label: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	groupId: PropTypes.string.isRequired,
	inputType: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired,
	handleSelect: PropTypes.func.isRequired
};

export default StoreList;
